// extracted by mini-css-extract-plugin
export var avatar = "_r3-3";
export var avatarContainer = "_r3-2";
export var avatarSpacer = "_r3-5";
export var avatarSpacerContainer = "_r3-4";
export var avatarStackContainer = "_r3-1";
export var bubble = "_r3-0";
export var remainderBubble = "_r3-6";